module.exports = "/img/user-guided-tours/customers-list/filters@2x.png?11de78e48266048791b8622f94ab6f56";